// [Project] > Settings > Settings history.
import { Link, useParams } from "react-router-dom";

import { SettingsHistory } from "../components/SettingsHistory";

export const ProjectSettingsHistoryRoute = () => {
  const { projectId } = useParams();
  const decoded = projectId ? decodeURIComponent(projectId) : "";
  return (
    <SettingsHistory
      scope={decoded ? { projectId: decoded } : null}
      intro={
        <>
          Every change to how this project is set up, newest first.{" "}
          <Link to={`/projects/${encodeURIComponent(decoded)}/settings`}>Back to settings</Link>
        </>
      }
    />
  );
};
